import React from 'react'
import { Drawer, Menu, Card, Row, Col, Typography, Button } from 'antd'
import { ReactComponent as BikeSvg } from './img/bike.svg'

import ScooterLogo from './img/scooter-wifi.png'
import TimerLogo from './img/timer.png'
import WalletLogo from './img/wallet.png'
import Icon, {
    GiftOutlined,
    SettingOutlined,
    QuestionOutlined,
    CreditCardOutlined
} from '@ant-design/icons';
import ProtectedArea from 'components/ProtectedArea';
import './userMenu.css'
import Currency from 'components/Currency'

const BikeIcon = props => <Icon component={BikeSvg} {...props} />;

const Meta = Card.Meta
const { Title, Text } = Typography


export default function UserMenuView({
    visible, onClose,
    onCredit, onGift, onSetting, onGuide, onPayments,
    onSubscription, onTrips, ridesSummary, userFirstName,
    activeSubscriptionName, walletBalance
}) {
    console.log(activeSubscriptionName)
    return <Drawer visible={visible} placement="right" onClose={onClose} closable={false} zIndex={2000}>
        <Row><Title level={4} className='mb-36 mt-2'>{"سلام " + (userFirstName || "کاربر میهمان")}</Title></Row>
        <ProtectedArea>
            <Row>
                <Col span={24}>
                    <p className='menu-current-credit'>
                        اعتبار در رورو:
                        &nbsp;
                        <Currency value={walletBalance || 0} />
                    </p>
                </Col>
                <Col span={24} justify='center'>
                    <Row justify='center'>
                        <button onClick={onCredit} className='ant-btn ant-btn-primary menu-charge-credit-btn '>
                            افزایش اعتبار
                        </button>
                    </Row>
                </Col>
            </Row>
            <hr className='menu-divider' />
            <Row className='ride-time-container mt-1'>
                <Col span={12}>
                    <Row justify='center'>
                        <img src={ScooterLogo} alt="" />
                    </Row>
                    <Row justify='center'>
                        <Text
                            className='ride-count'>{ridesSummary !== undefined ? ridesSummary.rideNumber.toString() : "0"}</Text>
                    </Row>
                    <Row justify='center'>
                        <Text className='ride-title'>سفر</Text>
                    </Row>

                </Col>
                <Col span={12}>
                    <Row justify='center'>
                        <img src={TimerLogo} alt="" />
                    </Row>
                    <Row justify='center'>
                        <Text
                            className='time-count'>{ridesSummary !== undefined ? ridesSummary.userRidingHours.toString() : "0"}</Text>
                    </Row>
                    <Row justify='center'>
                        <Text className='time-title'>ساعت</Text>
                    </Row>
                </Col>
            </Row>
            <Row className='protected-area-container' onClick={onSubscription}>
                <Col span={24} className='protected-area-child subscription-title-container '>
                    <Row justify='center'>
                        <img src={WalletLogo} className='subscription-img' alt="" />
                        <Text className='subscription-title'>خرید بسته های اشتراک</Text>
                    </Row>
                    <Row justify='center'>
                        <Text className='subscription-text'>
                            {(activeSubscriptionName || "با خرید اشتراک رورو، ارزانتر سفر کنید")}
                        </Text>
                    </Row>
                </Col>


            </Row>
            <Menu className='roro-drawer-menu'>
                <Menu.Item onClick={onGift}><GiftOutlined /> کد هدیه و تخفیف</Menu.Item>
                <Menu.Item onClick={onTrips}><BikeIcon /> تاریخچه سفرها</Menu.Item>
                <Menu.Item onClick={onPayments}><CreditCardOutlined /> تاریخچه پرداخت ها</Menu.Item>
                <Menu.Item onClick={onSetting}><SettingOutlined /> اطلاعات کاربری</Menu.Item>
                <Menu.Item onClick={onGuide}><QuestionOutlined /> راهنما</Menu.Item>

            </Menu>
        </ProtectedArea>

    </Drawer>
}
